import dynamic from "next/dynamic";
import { useState, useEffect } from "react";
import {
  Typography,
  Spin,
  Modal,
  Input,
  Button,
  Form,
  notification,
  Tag,
  Select,
} from "antd";
import { convert } from "../../utils/convert";
import { useSelector, useDispatch } from "react-redux";
import { getCurrencyData } from "../../redux/actions/currencyActions";
import { useRouter } from "next/router";
import { Api } from "../../networks/Api";
import axios from "axios";
import { CloseOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import NextImage from "next/image";
import ThumborJS from "thumborjs";
const CartComponent = dynamic(() => import("../../components/CartData"));

const { Title, Text } = Typography;

const imageUrl = process.env.NEXT_PUBLIC_IMAGE_URL;
const thumborKey = process.env.NEXT_PUBLIC_THUMBOR_KEY;
const thumborUrl = process.env.NEXT_PUBLIC_THUMBOR_URL;

const summaryImageLoader = ({ src, width }) => {
  if (src.split("?")?.length > 1) {
    return `${src}`;
  }
  const tugen = new ThumborJS(thumborUrl, thumborKey);
  return tugen
    .imgpath(src)
    .resize(width, width)
    .filter("format(webp)")
    .genurl();
};

const getProductImage = (product) => {
  const image_path = product?.imagepath_compress?.replace(/uploads\//g, "");
  if (product?.imagepath_compress) return `${imageUrl}/${image_path}`;
  if (product?.imagepath) return product?.imagepath;
  return `${process.env.NEXT_PUBLIC_FRONTEND_URL}/static/images/thumbnail.jpeg`;
};

const getProductBrand = (product) =>
  product?.brand_name ||
  product?.brand?.name_en ||
  product?.brand?.name ||
  product?.brand ||
  "";

const Summary = ({
  t,
  deliveryType,
  voucher,
  setVoucher,
  voucherDelivery,
  setVoucherDelivery,
  setFormAddress,
  setAddressSelect,
  addressId,
  token,
  deliveryAmount,
  setDeliveryAmount,
  setLoading,
}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { pathname } = router;
  const redux_cart = useSelector((state) => state?.cart);
  const redux_fingerprint = useSelector((state) => state?.fingerprint);
  const { currencyData } = useSelector((state) => state?.currency);

  // const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [total, setTotal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [vat, setVat] = useState(0);
  const [delivery, setDelivery] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [memberDiscount, setMemberDiscount] = useState(0);
  const [currencyOption, setCurrencyOption] = useState([]);
  const [cartData, setCartData] = useState();

  const [voucherForm] = Form.useForm();

  const openNotificationError = (msg) => {
    notification.open({
      message: "Notice",
      description: msg,
      placement: "top",
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = `${Api.getCurrencyexchangeList}`;
        const response = await axios.get(url, Api.Header());
        if (response?.status == 200) {
          const data = response?.data?.data;
          setCurrencyOption(data);
        }
      } catch (e) {
        console.log("fetchData >> getCurrencyexchangeList error :", e);
      }
    };

    fetchData();
  }, []);

  const onFinishSuccess = async (values) => {
    setLoading(true);
    const voucher_code = values.voucher;
    try {
      const url = `${
        token ? Api.checkVoucherAuth : Api.checkVoucher
      }/${voucher_code}/${
        redux_fingerprint?.fingerprintData
      }?platform=website&delivery_type=${deliveryType}`;
      // const response = await axios.get(url, Api.Header());
      const response = await axios.get(url, Api.Header(token));
      if (response?.status == 200) {
        const datas = response.data.data;

        if (datas?.status == "used") {
          openNotificationError("Voucher has used.");
        } else if (datas?.status == "expired") {
          openNotificationError("Voucher has expired.");
        } else if (datas?.status == "inactive") {
          openNotificationError(datas?.message_en || "Voucher has inactive.");
        } else {
          notification.open({
            message: "Success.",
            description: `Activate voucher`,
            placement: "top",
          });
          // if (datas?.voucher_type == "delivery_discount") {
          //   setVoucherDelivery(datas);
          // } else {
          //   setVoucher(datas);
          // }
          setVoucher(datas);
        }
        voucherForm.setFieldsValue({
          voucher: "",
        });
        setLoading(false);
        setOpen(false);
      } else if (response?.status == 404) {
        openNotificationError(`${t("no-voucher")}`);
      }
    } catch (error) {
      setLoading(false);
      if (error?.response?.status == 404) {
        openNotificationError(`${t("no-voucher")}`);
      } else {
        openNotificationError(
          error?.response?.data?.data || error?.data?.message || error?.message,
        );
      }
    }
  };

  const onFinishFailed = (e) => {
    console.log(e);
    message.error("Submit failed!");
  };

  const changeCurrency = (currency) => {
    const day = 7;
    Cookies.set("currency", currency, { expires: day, path: "/" });
    dispatch(getCurrencyData(currency));
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const profileResponse = token
          ? await axios.get(Api.UserProfile, Api.Header(token))
          : {};
        const channel = profileResponse?.data?.data?.channel || "website";
        const cart = redux_cart?.cartData;
        const cart_id = cart?.map((v) => v.id);
        let delivery_type =
          deliveryType == "delivery" && !addressId ? "store" : deliveryType;
        if (cart_id?.length > 0) {
          const postData = {
            cart_id: cart_id,
            delivery_type: delivery_type || "store",
            voucher: voucher?.code || "",
            delivery_voucher: voucherDelivery?.code || "",
            platform: "website",
            address_id: addressId,
            uuid: redux_fingerprint?.fingerprintData,
            channel,
          };
          const url = `${Api.getOrderSummary}`;
          const response = await axios.post(
            url,
            postData,
            Api.Header(token ? token : ""),
          );
          if (response?.status == 200) {
            const data = response?.data?.data?.currency[currencyData];
            setCartData(cart);
            setTotal(data?.sub_total);
            setGrandTotal(data?.total_amount);
            setVat(data?.vat);
            setDelivery(data?.delivery_amount);
            setDiscount(data?.voucher_discount);
            setMemberDiscount(data?.member_discount || 0);
            if (setDeliveryAmount) setDeliveryAmount(data?.delivery_amount);
          }
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log("fetchData >> getOrderSummary error :", error);
        setAddressSelect("");
        setFormAddress("");
        openNotificationError(error?.response?.data);
      }
    };

    fetchData().catch(console.error);
  }, [
    token,
    redux_cart,
    deliveryType,
    currencyData,
    voucher,
    voucherDelivery,
    addressId,
    setLoading,
    redux_fingerprint?.fingerprintData,
    setAddressSelect,
    setDeliveryAmount,
    setFormAddress,
  ]);

  return (
    <Spin spinning={false}>
      <Modal
        className="ant-modal-center"
        title={`${t("voucher")}`}
        centered
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        footer={false}
      >
        <Form
          form={voucherForm}
          name="voucher"
          layout="vertical"
          onFinish={onFinishSuccess}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            name="voucher"
            label={t("code")}
            rules={[
              {
                required: true,
                message: `${t("err-require")}${t("voucher")}.`,
              },
              { type: "string" },
            ]}
          >
            <Input className="input-login" size="large" />
          </Form.Item>
          <Form.Item>
            <Button
              className="btn-login"
              block
              type="primary"
              htmlType="submit"
            >
              {t("submit")}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <div className="checkout-summary">
        <div className="summary-eyebrow">{t("order-summary")}</div>

        {pathname != "/cart" && redux_cart?.cartData?.length > 0 && (
          <div className="summary-items">
            {redux_cart.cartData.map((v) => {
              const brand = getProductBrand(v?.product);
              const itemPrice =
                v?.discount?.[currencyData]?.totalprice ??
                v?.currency?.[currencyData]?.totalprice ??
                v?.totalprice;
              return (
                <div className="summary-item" key={`summary-item-${v?.id}`}>
                  <div className="summary-item-img">
                    <NextImage
                      loader={summaryImageLoader}
                      src={getProductImage(v?.product)}
                      alt={v?.product?.name || "product"}
                      layout="fill"
                      objectFit="contain"
                    />
                  </div>
                  <div className="summary-item-info">
                    {brand && (
                      <span className="summary-item-brand">{brand}</span>
                    )}
                    <span className="summary-item-name">
                      {v?.product?.name}
                    </span>
                    <span className="summary-item-qty">
                      {t("qty")} {v?.number}
                    </span>
                  </div>
                  <div className="summary-item-price">
                    {convert(itemPrice, 2)} {currencyData.toUpperCase()}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {pathname != "/cart" && (
          <>
            <div className="summary-divider" />
            <div className="summary-row">
              <Text className="summary-row-label">{t("currency-text")}</Text>
              <Select
                key={`items1-7`}
                value={currencyData}
                variant="unstyled"
                onChange={(e) => {
                  changeCurrency(e);
                }}
                options={currencyOption.map((option) => ({
                  value: option.value,
                  label: (
                    <div className="currency-select-text">
                      <div className="text">{option.label}</div>
                      <div className="symbol">({option.symbol})</div>
                    </div>
                  ),
                }))}
              />
            </div>
            <div className="summary-row">
              <Text className="summary-row-label">{t("voucher")}</Text>
              <a
                href="#"
                className="summary-voucher-link"
                style={voucher?.code ? { color: "#000000" } : {}}
                onClick={() => {
                  setOpen(true);
                }}
              >
                {t("voucher-use")}
              </a>
            </div>
            {(voucher || voucherDelivery) && (
              <div className="summary-tags">
                {voucher && (
                  <Tag
                    key={voucher?.code}
                    closable={true}
                    style={{ userSelect: "none" }}
                    onClose={() => setVoucher("")}
                  >
                    <span>{voucher?.title_en}</span>
                  </Tag>
                )}
                {voucherDelivery && (
                  <Tag
                    key={voucherDelivery?.code}
                    closable={true}
                    style={{ userSelect: "none" }}
                    onClose={() => setVoucherDelivery("")}
                  >
                    <span>{voucherDelivery?.title_en}</span>
                  </Tag>
                )}
              </div>
            )}
          </>
        )}

        <div className="summary-divider" />

        <div className="summary-row">
          <Text className="summary-row-label">{t("subtotal")}</Text>
          <Text className="summary-row-value">
            {convert(total, 2)} {currencyData.toUpperCase()}
          </Text>
        </div>
        <div className="summary-row">
          <Text className="summary-row-label">{t("vat")}</Text>
          <Text className="summary-row-value">
            {convert(vat, 2)} {currencyData.toUpperCase()}
          </Text>
        </div>
        {discount != 0 && (
          <div className="summary-row">
            <Text className="summary-row-label">{t("discount")}</Text>
            <Text className="summary-row-value">
              {convert(discount, 2)} {currencyData.toUpperCase()}
            </Text>
          </div>
        )}
        {memberDiscount != 0 && (
          <div className="summary-row">
            <Text className="summary-row-label">{t("member-discount")}</Text>
            <Text className="summary-row-value">
              {convert(memberDiscount, 2)} {currencyData.toUpperCase()}
            </Text>
          </div>
        )}
        {delivery != 0 && (
          <div className="summary-row">
            <Text className="summary-row-label">{t("delivery")}</Text>
            <Text className="summary-row-value">
              {convert(delivery, 2)} {currencyData.toUpperCase()}
            </Text>
          </div>
        )}

        <div className="summary-divider" />
        <div className="summary-row summary-total">
          <span>{t("total-due-today")}</span>
          <span>
            {convert(grandTotal, 2)} {currencyData.toUpperCase()}
          </span>
        </div>
      </div>
    </Spin>
  );
};

export default Summary;
